/**
 * 分享功能 API
 */
import api from '@/services/api';

export default {
  /**
   * 创建分享
   */
  createShare(productId, channel = 'whatsapp') {
    return api.post('/customer/share', null, {
      params: { productId, channel }
    });
  },

  /**
   * 获取我的分享统计
   */
  getMyStats(stallId) {
    return api.get('/customer/share/my-stats', {
      params: { stallId }
    });
  },

  /**
   * 获取我的分享记录
   */
  getMyRecords(stallId, page = 0, size = 20) {
    return api.get('/customer/share/my-records', {
      params: { stallId, page, size }
    });
  },

  /**
   * 获取我的奖励记录
   */
  getMyRewards(stallId, page = 0, size = 20) {
    return api.get('/customer/share/my-rewards', {
      params: { stallId, page, size }
    });
  },

  /**
   * 获取分享落地页数据（公开接口）
   */
  getSharePage(shareCode, stallId) {
    return api.get(`/public/share/${shareCode}`, {
      params: { stallId }
    });
  }
};
